import type { Actions } from './types.tsx';

export const actions: Actions = {
	onDisableAITourUserPreference:
		() =>
		(_, { onDisableAITourUserPreference }) => {
			onDisableAITourUserPreference();
		},
	onEndAITour:
		() =>
		({ setState }) => {
			setState({ isAITourEnabled: false });
		},
};
